import * as React from 'react';
type Props = {
  className?: string;
};
export function ThumbsDownFilled({ className }: Props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="utility-thumbs-down-filled"
      className={className}
    >
      <path
        d="M15.86 3H7.464C6.90144 3 6.35405 3.18246 5.904 3.52C5.45395 3.85754 5.12541 4.33231 4.96789 4.87237L3.1039 11.2723C2.99097 11.6597 2.96975 12.0681 3.04194 12.4651C3.11414 12.8622 3.27782 13.2371 3.52 13.56C3.76218 13.8829 4.07622 14.145 4.43724 14.3255C4.79827 14.506 5.19636 14.6 5.6 14.6H8.99225L8.49315 16.6563L8.49267 16.6583C8.36658 17.1702 8.35766 17.7041 8.46658 18.22C8.57564 18.7366 8.80002 19.2218 9.12297 19.6395C9.44592 20.0572 9.85907 20.3965 10.3316 20.6321C10.8041 20.8676 11.3237 20.9934 11.8516 20.9999C12.2346 21.0047 12.5867 20.7902 12.7582 20.4477L15.5182 14.9357L15.5195 14.933C15.5692 14.833 15.6458 14.7489 15.7406 14.6901C15.7784 14.6667 15.8184 14.6477 15.86 14.6332L15.86 3Z"
        fill="currentColor"
      />
      <path
        d="M17.86 14.6H18.264C18.9536 14.6 19.6149 14.3261 20.1025 13.8385C20.5901 13.3509 20.864 12.6896 20.864 12V5.6C20.864 4.91044 20.5901 4.24912 20.1025 3.76152C19.6149 3.27393 18.9536 3 18.264 3H17.86L17.86 14.6Z"
        fill="currentColor"
      />
    </svg>
  );
}
